export const KPK_CODE_LENGTH = 8;

export const KPK_JOIN_ERROR_STATUSES = {
    CODE_ALREADY_EXISTS: 400,
    CODE_IS_INVALID: 422,
} as const;

export type KPK_JOIN_ERROR_IDS = (typeof KPK_JOIN_ERROR_IDS)[keyof typeof KPK_JOIN_ERROR_IDS];
// eslint-disable-next-line no-redeclare
export const KPK_JOIN_ERROR_IDS = {
    COURSE_NOT_FOUND: 'course_not_found',
    CODE_WAS_USED: 'code_was_used',
    CODE_INVALID: 'code_invalid',
    NETWORK: 'network',
    CODE_ALREADY_USED: 'code_already_used',
    CODE_IS_EMPTY: 'empty',
} as const;
